// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels, useTagging, useFormat } from 'utilities/hooks';

// Components
import Card from 'components/_cardContentElements';
import Tags from 'components/tags';

const ActivityEvaluationComponent = ({
    item,
    theme = 'teal',
    wrap = false,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const format = useFormat();
    const { dataSet, getValueLabel, object, label } = useLabels();
    const tagging = useTagging({
        relationKey: 'Initiative_Activity__c',
    });

    // ///////////////////
    // DATA
    // ///////////////////

    const { Activity_Start_Date__c, Activity_End_Date__c } = item;

    const country = item?.Initiative_Location__c
        ? dataSet('Countries').find(
              c => c.value === item?.Initiative_Location__c
          )?.label ?? null
        : null;

    const otherLocation = item?.Additional_Location_Information__c;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <Card.CardContentWrapper
            {...{
                wrap,
            }}>
            {/* Evaluation tyåe */}
            <Card.CardContentSection
                {...{
                    theme,
                    wrap,
                    title: object.label(
                        'Initiative_Activity__c.Whos_Evaluating__c'
                    ),
                }}>
                <p>
                    {getValueLabel(
                        'Initiative_Activity__c.Whos_Evaluating__c',
                        item?.Whos_Evaluating__c
                    )}
                </p>
            </Card.CardContentSection>

            {/* Description */}
            <Card.CardContentSection
                {...{
                    theme,
                    wrap,
                }}>
                <p>{item?.Things_To_Do_Description__c}</p>
            </Card.CardContentSection>

            {/* Start date / End date  */}
            {Activity_Start_Date__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                        title: object.label(
                            'Initiative_Activity__c.Dates_Label'
                        ),
                    }}>
                    <p>
                        {format.date(Activity_Start_Date__c)}
                        {Activity_End_Date__c
                            ? ` - ${format.date(Activity_End_Date__c)}`
                            : ''}
                    </p>
                </Card.CardContentSection>
            )}

            {/* Location */}
            {[country, otherLocation].some(x => x) && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                        title: object.label(
                            'Initiative_Activity__c.Initiative_Location__c'
                        ),
                    }}>
                    <p>
                        {otherLocation && otherLocation}
                        {otherLocation && country && `, `}
                        {country && country}
                    </p>
                </Card.CardContentSection>
            )}

            {/* Tags */}
            {tagging?.getCurrentTags(item).length > 0 && (
                <Card.CardContentSection
                    {...{
                        theme,
                        title: label('DetailsTagsActivities'),
                    }}>
                    <Tags
                        {...{
                            theme,
                            tags: tagging?.getCurrentTags(item),
                            className: 'mt-4',
                        }}
                    />
                </Card.CardContentSection>
            )}
        </Card.CardContentWrapper>
    );
};

ActivityEvaluationComponent.propTypes = {
    item: t.object,
};

ActivityEvaluationComponent.defaultProps = {};

export default ActivityEvaluationComponent;
